const books = [
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511811766/fcweb/fc-book-barkingupthewrongtree_sk5uga.jpg',
    title: 'Barking Up The Wrong Tree',
    price: '18.30',
    affiliate_link: 'http://amzn.to/2ztvyoA'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511811943/fcweb/fc-book-fifthTrimester_kfsumj.jpg',
    title: 'The Fifth Trimester',
    price: '17.64',
    affiliate_link: 'http://amzn.to/2zsN2Bo'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812041/fcweb/fc-book-technicallyWrong_emqybr.jpg',
    title: 'Technically Wrong',
    price: '16.18',
    affiliate_link: 'http://amzn.to/2ztLcjH'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812117/fcweb/fc-book-perennialSeller_vbfloh.jpg',
    title: 'Perennial Seller',
    price: '14.67',
    affiliate_link: 'http://amzn.to/2AcDbTk'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812219/fcweb/fc-book-crackInCreation_kyn5nw.jpg',
    title: 'A Crack in Creation',
    price: '18.61',
    affiliate_link: 'http://amzn.to/2zuqSyU'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812368/fcweb/fc-book-greatTransformation_m2rbhw.jpg',
    title: 'The Great Transformation',
    price: '22.85',
    affiliate_link: 'http://amzn.to/2BrORQD'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812472/fcweb/fc-book-deepLearning_m8admo.jpg',
    title: 'Deep Learning',
    price: '47.00',
    affiliate_link: 'http://amzn.to/2k7zRDn'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812561/fcweb/fc-books-boysintheBoat_jgqdvx.jpg',
    title: 'The Boys in the Boat',
    price: '12.27',
    affiliate_link: 'http://amzn.to/2i7oLNX'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812647/fcweb/fc-book-greatConvergence_cbci1g.jpg',
    title: 'The Great Convergence',
    price: '22.84',
    affiliate_link: 'http://amzn.to/2BtoeuH'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812771/fcweb/fc-book-mindset_htkqvr.jpg',
    title: 'Mindset',
    price: '13.60',
    affiliate_link: 'http://amzn.to/2zscLtJ'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812898/fcweb/fc-book-nonViolentCommunication_fqvqed.jpg',
    title: 'Nonviolent Communication',
    price: '13.50',
    affiliate_link: 'http://amzn.to/2ztH4Ag'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813012/fcweb/fc-books-americanGrowth_swbtwj.jpg',
    title: 'The Rise and Fall of American Growth',
    price: '18.67',
    affiliate_link: 'http://amzn.to/2BtIAns'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813368/fcweb/fc-book-weaponsofMathDestruction_ziestc.jpg',
    title: 'Weapons of Math Destruction',
    price: '17.68',
    affiliate_link: 'http://amzn.to/2Bpln5M'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813416/fcweb/fc-book-urbanCrisis_ff1h7i.jpg',
    title: 'The New Urban Crisis',
    price: '19.04',
    affiliate_link: 'http://amzn.to/2iaCKCs'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813498/fcweb/fc-book-whiplash_ienuxv.jpg',
    title: 'Whiplash',
    price: '17.41',
    affiliate_link: 'http://amzn.to/2zrZt0d'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813630/fcweb/fc-book-playAnything_qgpjgn.jpg',
    title: 'Play Anything',
    price: '15.68',
    affiliate_link: 'http://amzn.to/2BrLHfC'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813735/fcweb/fc-book-dataGoliath_fi8pcv.jpg',
    title: 'Data and Goliath',
    price: '12.80',
    affiliate_link: 'http://amzn.to/2ztMKdv'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813817/fcweb/fc-books-powerofMoments_noieau.jpg',
    title: 'The Power of Moments',
    price: '17.38',
    affiliate_link: 'http://amzn.to/2zt43eS'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813916/fcweb/fc-book-tribeofMentors_bfaqkb.jpg',
    title: 'Tribe of Mentors',
    price: '17.85',
    affiliate_link: 'http://amzn.to/2BsKcho'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813976/fcweb/fc-book-startupWay_cmmoxs.jpg',
    title: 'The Startup Way',
    price: '17.98',
    affiliate_link: 'http://amzn.to/2zsmWyC'
  },
  {
    cover:
      'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511814039/fcweb/fc-book-secondMachineAge_npugcp.jpg',
    title: 'The Second Machine Age',
    price: '14.83',
    affiliate_link: 'http://amzn.to/2zt5rOC'
  }
];

export default books;
